/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_SubtitleInputs */

const cs_audit_subtitle = /** @type {(inputs: Audit_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kdo co změnil v Cerebrio.`)
};

const en_audit_subtitle = /** @type {(inputs: Audit_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who changed what in Cerebrio.`)
};

/**
* | output |
* | --- |
* | "Who changed what in Cerebrio." |
*
* @param {Audit_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_subtitle = /** @type {((inputs?: Audit_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_subtitle(inputs)
	return cs_audit_subtitle(inputs)
});